// =============================================
// SERVICIO DE ESTADO DE CUENTA
// =============================================

import api from './api';

const accountStatementService = {
  // Obtener estado de cuenta consolidado
  getStatement: async (filters = {}) => {
    const params = {};
    if (filters.start_date) params.start_date = filters.start_date;
    if (filters.end_date) params.end_date = filters.end_date;
    if (filters.transaction_type) params.transaction_type = filters.transaction_type;
    if (filters.user_id) params.user_id = filters.user_id;
    if (filters.month) params.month = filters.month;
    if (filters.year) params.year = filters.year;

    const response = await api.get('/account-statement', { params });
    return response.data;
  },

  // Obtener estado de cuenta por propietario
  getOwnerStatement: async (userId, filters = {}) => {
    const params = {};
    if (filters.start_date) params.start_date = filters.start_date;
    if (filters.end_date) params.end_date = filters.end_date;

    const response = await api.get(`/account-statement/owner/${userId}`, { params });
    return response.data;
  },
};

export default accountStatementService;
